type AllowedMetaProperty = 'og:url' | 'og:type' | 'fb:app_id' | 'og:title' | 'og:description' | 'og:site_name' | 'og:locale' | 'og:locale:alternate' | 'og:image'
export const getMetaProperty = ({ property, content }: { property: AllowedMetaProperty, content: string }) => ({ property, content })
